import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { ACCESS_LEVEL_META } from '../../constants/copy';

/**
 * Access-level suffix of a row that is on ("· Own", "· Groups", "· Tenant").
 *
 * @param {object} props
 * @param {'own'|'groups'|'tenant'} props.level
 */
const PermissionLevelSuffix = ({ level }) => {
  const { t } = useTranslation('people-access');
  const meta = ACCESS_LEVEL_META[level];

  if (!meta) return null;

  return <span className="text-xs text-content-muted">{`· ${t(meta.labelKey)}`}</span>;
};

export default memo(PermissionLevelSuffix);
